import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _GridLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("rect", { width: 4.333, height: 6, x: 3.5, y: 14, stroke: "currentColor", strokeLinecap: "round", rx: 0.5 }),
            React.createElement("rect", { width: 4.333, height: 6, x: 9.833, y: 14, stroke: "currentColor", strokeLinecap: "round", rx: 0.5 }),
            React.createElement("rect", { width: 4.333, height: 6, x: 16.167, y: 14, stroke: "currentColor", strokeLinecap: "round", rx: 0.5 }),
            React.createElement("rect", { width: 4.333, height: 6, x: 3.5, y: 4, stroke: "currentColor", strokeLinecap: "round", rx: 0.5 }),
            React.createElement("rect", { width: 4.333, height: 6, x: 9.833, y: 4, stroke: "currentColor", strokeLinecap: "round", rx: 0.5 }),
            React.createElement("rect", { width: 4.333, height: 6, x: 16.167, y: 4, stroke: "currentColor", strokeLinecap: "round", rx: 0.5 })));
}
const GridLight = forwardRef(_GridLight);
export { GridLight };
